import { SimpleBlock, TextLink } from 'ui-builder';
import React, { useState } from 'react';

import styles from './NewMarketWidget.module.scss';
import { InformationMessage } from 'features/nekst-widgets';
import useSettingsNavigator from '../settingsNavigator';
import { RequestNewMarketToggleWrapper } from 'feature-toggle';

export default function NewMarketWidget() {

  const [enabled, setEnabled] = useState(false);

  const settingsNavigator = useSettingsNavigator();

  return (
    <RequestNewMarketToggleWrapper>
      <SimpleBlock>
        {!enabled && (<TextLink
          className={styles.newMarketLink}
          onClick={async () => {
            setEnabled(true);
          }}
        >
          Do not see your market?
        </TextLink>)}
        {enabled && (
          <InformationMessage>
            We are actively adding new markets. In order to setup a new market,
            please provide sample documents for us to utilize for setup.
            {' '}
            <TextLink
              onClick={async () => {
                settingsNavigator.openMarketRequestsPage(true);
              }}
            >
              Click here to request a new market setup.
            </TextLink>
          </InformationMessage>
        )}
      </SimpleBlock>
    </RequestNewMarketToggleWrapper>
  );
}
